
import { Injectable } from '@angular/core';
import {  Actions, ofType, createEffect } from '@ngrx/effects';
import { LoadMatchingGiftState, LoadMatchingGiftStateSuccess, LoadMatchingGiftStateFail, MatchingGiftActionTypes, IUDMatchingGiftState, IUDMatchingGiftStateSuccess, arwMatchingGiftSuccess, arwMatchingGift } from './matching-gift.actions';
import { IMatchingGift, LGEDataService } from '../../../commons';
import { catchError, map, switchMap } from 'rxjs/operators';
import { from, of } from 'rxjs';
@Injectable()
export class MatchingGiftEffects {

    loadMatchingGiftState$ = createEffect(
        () => this.actions$.pipe(
            ofType(MatchingGiftActionTypes.LoadMatchingGiftState),
            map((action: LoadMatchingGiftState) => action.Id),
            switchMap((formId) =>
                from(this.lgeService.formMGById(formId)).pipe(
                    map((state: IMatchingGift) => new LoadMatchingGiftStateSuccess(state)),
                    catchError((error:Error) => of(new LoadMatchingGiftStateFail(error)))
                )
            )
        )
    )

    IUDMatchingGiftState$ = createEffect(
        () => this.actions$.pipe(
            ofType(MatchingGiftActionTypes.IUDMatchingGiftState),
            map((action: IUDMatchingGiftState) => [action.payload, action.approvalData]),
            switchMap((data: any) =>
                from(this.lgeService.mgFormIUD(data[0]))
                    .pipe(
                        map(() => {
                            if (data[1] !== null) {
                                return new arwMatchingGift(data[1]);
                            } else {
                                return new IUDMatchingGiftStateSuccess(data[0].statusId)
                            }

                        }),
                        catchError((error:Error) => of(new LoadMatchingGiftStateFail(error)))
                    )
            )
        )
    )
    // approve reject withdrawn
    arwMatchingGift$ = createEffect(
        () => this.actions$
            .pipe(
                ofType(MatchingGiftActionTypes.arwMatchingGift),
                map((action: arwMatchingGift) => action.payload),
                switchMap((approvalData) =>
                    from(this.lgeService.AprrovedOrRejectFormMG(approvalData))
                        .pipe(map((msg) => {
                            let successMsg = '';
                            if (msg !== 'ALREADYDONE') {
                                successMsg = `Successfully ${msg}!`
                            } else {
                                successMsg = 'This request has already been approved!!'
                            }
                            return new arwMatchingGiftSuccess(successMsg);

                        }),
                        catchError((error:Error) => of(new LoadMatchingGiftStateFail(error)))
                        )
                )
            )
    );

constructor(
    private actions$: Actions,
    private lgeService: LGEDataService
) { }

}